import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0049',
    ecrans: ['00-2'],
    params: ['id', '?vaesysnatctb', '?indcleint', '?annfindeb', '?vaeprutypbdg']
});
